import { z } from 'zod';

export const directorEnquirySchema = z.object({
    idNo: z.string().length(13, "ID Number must be 13 digits").regex(/^\d+$/, "ID Number must be numeric").optional().or(z.literal('')),
    passportNo: z.string().regex(/^[a-zA-Z0-9]+$/, "Passport Number must be alphanumeric").optional().or(z.literal('')),
    firstName: z.string().optional().or(z.literal('')),
    surname: z.string().optional().or(z.literal('')),
    dob: z.string().refine((val) => !val || new Date(val) <= new Date(), "Date of Birth cannot be in the future").optional().or(z.literal('')),
    voucherCode: z.string().optional().or(z.literal('')),
    yourReference: z.string().optional().or(z.literal('')),
}).superRefine((data, ctx) => {
    // Treat empty strings as undefined for logic
    const idNo = data.idNo === '' ? undefined : data.idNo;
    const passportNo = data.passportNo === '' ? undefined : data.passportNo;
    const firstName = data.firstName === '' ? undefined : data.firstName;
    const surname = data.surname === '' ? undefined : data.surname;
    const dob = data.dob === '' ? undefined : data.dob;

    const hasID = !!idNo;
    const hasPassport = !!passportNo;
    const hasFullDetails = !!firstName && !!surname && !!dob;

    if (!hasID && !hasPassport && !hasFullDetails) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Please provide either an ID Number OR Passport Number OR First Name, Surname, and Date of Birth",
            path: ['idNo'], // Attach to first field for visibility
        });
    }

    // Improve feedback: If trying to search by details but missing some fields
    if (!hasID && !hasPassport && (firstName || surname || dob)) {
        if (!firstName) ctx.addIssue({ code: z.ZodIssueCode.custom, message: "First Name is required", path: ['firstName'] });
        if (!surname) ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Surname is required", path: ['surname'] });
        if (!dob) ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Date of Birth is required", path: ['dob'] });
    }
});

export type DirectorEnquiryPayload = z.infer<typeof directorEnquirySchema>;

export const directorEnquiryService = {
    createPayload: (formData: z.infer<typeof directorEnquirySchema>): DirectorEnquiryPayload => {
        return {
            ...formData
        };
    },

    executeReport: async (payload: DirectorEnquiryPayload): Promise<any> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post('/verification/director-enquiry', payload);
        return response.data;
    }
};
